import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center mb-2" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({ required: _ctx.input.required })
      }, _toDisplayString(_ctx.input.label), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (tier, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: "badge badge-light-primary me-2 mb-2"
        }, [
          _createTextVNode(_toDisplayString(tier) + " ", 1),
          _createElementVNode("i", {
            class: "bi bi-x ms-2 cursor-pointer",
            onClick: ($event: any) => (_ctx.$emit('remove', index))
          }, null, 8, _hoisted_4)
        ]))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "number",
      class: "form-control form-control-solid mb-2",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.temp) = $event)),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addTier && _ctx.addTier(...args)), ["enter"])),
      placeholder: "Προσθέστε level και πατήστε enter"
    }, null, 544), [
      [
        _vModelText,
        _ctx.temp,
        void 0,
        { number: true }
      ]
    ])
  ]))
}